import {
    DialogContent,
    DialogTitle,
    Grid,
    TextField,
    Checkbox, FormControlLabel,
} from "@mui/material";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { DialogProps } from "../../types/Utils";
import FancyDialogActions from "./FancyDialogActions";

interface AddOrUpdateLocation {
  id?: number;
  name: string;
  variants: string;
  convertible?: boolean;
}

const AddOrUpdateUnitModal = ({
  data,
  onSubmit,
  cancelModal,
  modalType,
}: DialogProps) => {
    const validation = Yup.object().shape({
        name: Yup.string().required("Campo es requerido"),
        variants: Yup.string().required("Campo es requerido"),
    });

  const defaultValues = {
    id: data?.id ?? 0,
    name: data?.name ?? "",
    convertible: data?.convertible ?? false,
    variants: data?.variants ?? "",
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
  } = useForm<AddOrUpdateLocation>({
    defaultValues,
    resolver: yupResolver(validation),
    mode: "onChange",
  });

  return (
    <>
      <DialogTitle id="alert-dialog-title" sx={{ pt: 4, px: 4 }}>
        {modalType === "create"
          ? "Agregar unidad de bodega"
          : "Actualizar unidad de bodega"}
      </DialogTitle>
      <DialogContent sx={{ px: 4, pb: 0 }}>
        <form>
          <Grid container spacing={3} maxWidth="lg" sx={{ pt: 4, pb: 8 }}>
            <Grid item xs={12}>
              <Controller
                name={"name"}
                control={control}
                render={({ field: { value } }) => (
                  <TextField
                    fullWidth
                    size="small"
                    label={"Nombre"}
                    type="text"
                    variant="outlined"
                    value={value}
                    {...register("name")}
                    error={errors.name && Boolean(errors.name)}
                    helperText={errors.name && errors.name.message}
                    inputProps={{
                      autoComplete: "new-password",
                      form: {
                        autoComplete: "off",
                      },
                    }}
                    InputLabelProps={{ shrink: true }}
                  />
                )}
              />
            </Grid>
          <Grid item xs={12}>
            <Controller
              name={"variants"}
              control={control}
              render={({ field: { value } }) => (
                <TextField
                  fullWidth
                  size="small"
                  label={"Variants"}
                  type="text"
                  variant="outlined"
                  value={value}
                  {...register("variants")}
                  error={errors.variants && Boolean(errors.variants)}
                  helperText={errors.variants && errors.variants.message}
                  inputProps={{
                    autoComplete: "new-password",
                    form: {
                      autoComplete: "off",
                    },
                  }}
                  InputLabelProps={{ shrink: true }}
                />
              )}
            />
          </Grid>
              <Grid item xs={12}>
                  <Controller
                      name="convertible"
                      control={control}
                      render={({ field }) => (
                          <FormControlLabel
                              control={
                                  <Checkbox {...field} checked={Boolean(field.value)} />
                              }
                              label="Convertible"
                          />
                      )}
                  />
              </Grid>
        </Grid>
      </form>
    </DialogContent>
    <FancyDialogActions
      handleAccept={handleSubmit(onSubmit)}
      cancelModal={cancelModal}
    />
  </>
  );
};

export default AddOrUpdateUnitModal;
